/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/FormErrorBlock.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Thu Apr 17 2025
 */

import React, { useContext } from 'react';
import { TranslationsContext, FormContext } from "@proxy/_contexts";
import { Banner } from "@proxy/_components";

const FormErrorBlock = () => {

  const translations = useContext(TranslationsContext);
  const { formErrors } = useContext(FormContext);

  return ((Object.values(formErrors).length > 0) ?
    <Banner
      status="error"
    >
      <strong>
        {translations?.error_banner_title}
      </strong>
      <ul>
        {Object.values(formErrors).map((error: any, index: number) => (
          <li key={`gcpFormError${index}`}>
            {error?.message}
          </li>
        ))}
      </ul>
    </Banner>
  : null);
};

export default FormErrorBlock;
